// @flow
import { useContext } from 'react';

import { UserContext } from '../contexts/UserContext';
import { getIfUserIsAdminBasedOnGivenDetails } from '../common-utils/utils';

export const useUser = () => {
  const user = useContext(UserContext);
  return {
    isAdmin: getIfUserIsAdminBasedOnGivenDetails(user),
    email: user.name,
  };
};
